import React, { ForwardedRef, forwardRef, useState } from "react";
import styles from "./PhotoLogCard.module.scss";
import { Colors, UserForResolver } from "@factorearth/component-library";
import { FieldInstance } from "db/definitions";
import { UpdateContext } from "utils/UpdateContext";
import FieldAction from "components/FieldAction/FieldAction";
interface CardProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	colorPalette: Colors;
	rowData: FieldInstance[];
	buttons: React.ReactNode[] | React.JSX.Element[];
	online: boolean;
	setupDrawer: (location: Location | "") => void;
	userDoc: UserForResolver;
}

export const PhotoLogCard = forwardRef((props: CardProps, ref: ForwardedRef<HTMLDivElement>) => {
	const { rowData: rowDataProp, buttons, online, setupDrawer, userDoc, colorPalette } = props;
	const [rowData, setRowData] = useState(rowDataProp);

	function handleCellUpdate(updatedField: FieldInstance) {
		setRowData((prev) =>
			prev.map((cell) => (cell.id === updatedField.id ? { ...cell, value: updatedField.value, updatedAt: updatedField.updatedAt } : cell)),
		);
	}

	let rowFields: FieldInstance[] = [];

	rowData.map((field) => {
		if (field.fieldTemplate?.inputType !== "image") {
			rowFields.push(field);
		}
	});

	const imageData = rowData.find((item) => item?.fieldTemplate?.inputType === "image");

	function createFieldHtml(tableField: FieldInstance, rowData?: FieldInstance[]) {
		const isLink = !!(
			tableField.altInstanceId &&
			(tableField.fieldTemplate?.action?.includes("LINK") || tableField.fieldTemplate?.action?.includes("LINK_TO"))
		);
		const altId = tableField.altInstanceId;
		const altFieldInstance: FieldInstance | null = isLink
			? {
					...tableField,
					id: altId!,
					value: tableField.altInstance?.value ?? tableField.value ?? "",
					authors: tableField.altInstance?.authors ?? tableField.authors ?? [],
					altInstanceId: altId,
				}
			: null;

		return (
			<UpdateContext.Consumer key={`IMAGEROLLFIELD-${tableField.id}`}>
				{({ updateObj, setupChanged }) => (
					<div className={styles.inputsRow}>
						<FieldAction
							setupDrawer={setupDrawer}
							updateObj={isLink ? updateObj[altId!] : updateObj[tableField.id]}
							fieldInstance={isLink ? altFieldInstance : tableField}
							setupChanged={setupChanged}
							fieldTemplate={tableField.fieldTemplate}
							online={online}
							userDoc={userDoc}
							key={tableField.id + "-card"}
							fromTable={false}
							rowData={rowData}
							onSubmitCb={(data: { updatedField: FieldInstance }) => handleCellUpdate(data.updatedField)}
						/>
					</div>
				)}
			</UpdateContext.Consumer>
		);
	}

	return (
		<div
			className={styles.cardContainer}
			{...props}
			ref={ref}
			style={{ borderBottom: `solid 0.5px ${colorPalette.border.primary}` }}
			data-test="photo-log-card">
			<div className={styles.fieldsXThumbnailSection}>
				<div className={styles.thumbnail}>{imageData && createFieldHtml(imageData, rowData)}</div>
				<div className={styles.thumbnailSectionFields}>{rowFields.slice(0, 3).map((fieldInstance) => createFieldHtml(fieldInstance))}</div>
			</div>
			<div className={styles.remainingFields}>
				{rowFields.slice(3).map((fieldInstance) => {
					const hasRowData = fieldInstance?.fieldTemplate?.inputType === "image" ? rowData : undefined;
					return createFieldHtml(fieldInstance, hasRowData);
				})}
			</div>
			<div className={styles.buttonContainer}>{buttons.map((element) => element)}</div>
		</div>
	);
});
